import React from "react";

function EmptyState({ title, text }) {
  return (
    <div className="empty-state">
      <div>
        <div className="empty-state-icon">
          <i className="bi bi-inbox" />
        </div>
        <h5>{title}</h5>
        <p>{text}</p>
      </div>
    </div>
  );
}

export default EmptyState;
